<template>
  <div>

    <text-box-title title="Friendship Park Fishing Rules" class="mt-3">
      <div class="col-md-6 mt-3">
        <p>
          Bow hunting is permitted in Friendship Park, in restricted areas.  Hunting is allowed only during legal Ohio bow season.
        </p>
        <p class="text-bold font-size-125">
          There is no gun season
        </p>
      </div>

      <div class="col-md-6 mt-3">
        <ul class="fishing-list">
          <li>
            All Ohio hunt regulations are in effect.
          </li>
          <li>
            All hunters must seek park management for permit and orientation.  Management may  be reached at the park office by calling (740) 733-7941.
          </li>
          <li>
            One rod per fisherman.
          </li>
          <li>
            Hunters must abide by all other park rules and camping.
          </li>
        </ul>
      </div>
    </text-box-title>

  </div>
</template>

<script>
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import ResponseItem from '@/components/layout/ResponseItem.vue'

export default {
  components: {
    TextBoxTitle,
    ResponseItem
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>
  .fishing-list > li{
    margin-bottom: 0.75em;
    margin-left: 15px;
  }
</style>